import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { cn } from "@util/helpers";

type BTGSuccessMessageProps = {
  /** The class name of the component. */
  className?: string;
};

/**
 * The success message component for BTG newsletter.
 * https://www.figma.com/design/LHoF60AgvlnXcwv25cns5j/ARTICLE-PAGE--WEB---APP-?node-id=7315-57703&m=dev
 */
const BTGSuccessMessage = ({
  className,
}: BTGSuccessMessageProps): React.ReactElement => {
  return (
    <div
      data-testid="btg-success-message-component"
      className={cn("flex items-center justify-center gap-2", className)}
    >
      <IconFactory
        type={IconTypeEnum.check}
        className="flex-shrink-0 rounded-full bg-verticals-btblue text-white"
      />

      <span className="inline-block font-lucida font-medium italic leading-130 -tracking-5 text-gray-850">
        {"Thank you! You're now signed up."}
      </span>
    </div>
  );
};

export default BTGSuccessMessage;
